import React from 'react';
import { AddEllipsisToTextOverflow } from './AccountSelectorTruncatedTextWithoutTooltip.styles';

type AccountSelectorTruncatedTextWithoutTooltipProps = {
  children: React.ReactNode;
  maxWidth: string;
  'data-testid'?: string;
  hasBoldText?: boolean;
};

export const AccountSelectorTruncatedTextWithoutTooltip = ({
  children,
  maxWidth,
  'data-testid': dataTestId,
  hasBoldText,
}: AccountSelectorTruncatedTextWithoutTooltipProps) => (
  <AddEllipsisToTextOverflow hasBoldText={hasBoldText} data-testid={dataTestId} maxWidth={maxWidth}>
    {children}
  </AddEllipsisToTextOverflow>
);
